import { render, staticRenderFns } from "./post-editor.vue?vue&type=template&id=00adc687&"
import script from "./post-editor.vue?vue&type=script&lang=js&"
export * from "./post-editor.vue?vue&type=script&lang=js&"
import style0 from "./post-editor.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports